import React, { useState } from 'react'
import { Container } from './styles'
import { Pill } from '../../../shared_components'
import { useWindowSize } from '../../../hooks'

function GraphContainer({ Children, setRange, ranges, title, selectedRange, subTitle }) {

    const [expanded, setExpanded] = useState(true)
    const [fullScreen, setFullScreen] = useState(false)
    const windowSize = useWindowSize()

    const getGraphState = () => {
        let graphState = expanded ? 'bar_container_opened' : 'bar_container_closed'
        if(fullScreen) {
            graphState= 'full_screen_graph'
        }
        return graphState
    }
 

    return (
        <Container>
            <div className={getGraphState()}>
            <div className='bar_title_container'>
                    <div className='container_line'>
                        <div className='bar_title'>
                            <h5>{title}</h5>
                            {subTitle && <p>{subTitle}</p>}
                        </div>
                        <div className='bar_title_options'>
                            {windowSize.width > 1450 && <div className='bar_pill_container'>
                                {ranges && ranges.map((r, key) =>
                                    <Pill selected={selectedRange === r.value} key={key} text={r.name} onClick={() => setRange(r.value)} />
                                )}

                            </div>}


                            <div className='bar_graph_arrow_down' onClick={() => { setFullScreen(!fullScreen); setExpanded(true) }}>
                                <ion-icon name='resize-outline' />
                            </div>
                            {!fullScreen &&
                                <div className='bar_graph_arrow_down' onClick={() => setExpanded(!expanded)}>
                                    <ion-icon name='chevron-down-outline' />
                                </div>
                            }

                        </div>
                    </div>

                    {windowSize.width <= 1450 && <div className='bar_pill_container'>
                        {ranges && ranges.map((r, key) =>
                            <Pill selected={selectedRange === r.value} key={key} text={r.name} onClick={() => setRange(r.value)} />
                        )}

                    </div>}

                </div>

                {Children}

            </div>


        </Container>
    )
}

export default GraphContainer